import Dexie from 'dexie';

const table_name = 'userProfile';

interface IUserProfile {
  id?: string;
  userProfile: ArrayBuffer;
}

export class LoginDatabase extends Dexie {
  userProfile: Dexie.Table<IUserProfile, string>;

  constructor() {
    super('LoginDatabase');
    // Makes ID the only only index in the table indexable
    this.version(1).stores({
      userProfile: '',
    });

    this.userProfile = this.table(table_name);
  }
}
